import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const statusFilter = (): FilterDefinition => ({
  label: i18n.t('expenses_v2.list.header.status'),
  type: 'in',
  options: {
    options: [
      { label: i18n.t('expenses_v2.expense.status.pending'), value: 'pending' },
      { label: i18n.t('expenses_v2.expense.status.approved'), value: 'approved' },
      {
        label: i18n.t('expenses_v2.expense.status.changesRequested'),
        value: 'changes_requested',
      },
      { label: i18n.t('expenses_v2.expense.status.rejected'), value: 'rejected' },
      { label: i18n.t('expenses_v2.expense.status.inPayroll'), value: 'in_payroll' },
      { label: i18n.t('expenses_v2.expense.status.sentToPay'), value: 'sent_to_pay' },
      { label: i18n.t('expenses_v2.expense.status.paid'), value: 'paid' },
      { label: i18n.t('expenses_v2.expense.status.reversed'), value: 'reversed' },
      { label: i18n.t('expenses_v2.expense.status.draft'), value: 'draft' },
    ],
  },
})
